import { list_admin_payments } from "actions/paymentAction";
import AdminPaymentCardTable from "components/admin/AdminPaymentCardTable";
import React from "react";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

const AdminPayments = () => {
  const { adminPayments, loading } = useSelector((state) => state.payments);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(list_admin_payments());
  }, []);

  const props = {
    payments: adminPayments,
    loading,
  };
  return (
    <>
      <div className="bg-light-blue-500 pt-14 pb-28 px-3 md:px-8 h-auto">
        <div className="container mx-auto max-w-full"></div>
      </div>

      <div className="px-3 md:px-8 h-auto -mt-24">
        <div className="container mx-auto max-w-full">
          <div className="grid grid-cols-1 px-4 mb-16">
            <AdminPaymentCardTable {...props} />
          </div>
        </div>
      </div>
    </>
  );
};

export default AdminPayments;
